// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"a17cc028","87":"d9e138fc","410":"9db9aa68","453":"68693753","619":"01c16867","775":"0b19f0a4","861":"0a779d06","903":"dfd883f4","958":"b7b0b350"}[chunkId] + ".chunk.js";
};